import environment from 'environments/environment';

export const vfappmarket = environment.API_ENDPOINT.VF_MARKETPLACE;
export const vfappcatalog = environment.API_ENDPOINT.VF_APP_CATALOG;
export const entitiyservices = environment.API_ENDPOINT.ENTITY_SERVICE;
export const reportsServices = environment.API_ENDPOINT.REPORTS_SERVICE;
